import { createLogger } from 'common/log'

const logger = createLogger('gtmEvents')

const formatFilterEventData = ({ name, value, type, filterPosition }) => {
  const formattedData = {
    filter_category: name,
    filter_name: cleanValue(value, type)
  }
  if (filterPosition) formattedData.filter_position = filterPosition
  return formattedData
}
export const filterApplied = withTryCatch(filterActionData => {
  pushToDatalayer({ event: 'filter_applied', ...formatFilterEventData(filterActionData) })
})

export const filterRemoved = withTryCatch(filterActionData => {
  pushToDatalayer({ event: 'filter_removed', ...formatFilterEventData(filterActionData) })
})

export const pushAllFiltersEvent = withTryCatch(action => {
  pushToDatalayer({ event: 'all_filters', action })
})

export const sortChanged = withTryCatch(value => {
  pushToDatalayer({ event: 'filter_applied', filter_category: 'sorteren op', filter_name: mapSortingValues(value) })
})

const mapSortingValues = value => {
  if (value === 'price') return 'price-desc'
  return value
}

const cleanValue = (value, type) => {
  return value.replaceAll('"', '')
}

export function pushToDatalayer(e) {
  window?.dataLayer?.push(e)
}

function withTryCatch(func) {
  return (...args) => {
    try {
      return func(...args)
    } catch (error) {
      logger.error(error)
    }
  }
}
